import { render, staticRenderFns } from "./CreateOrderButton.vue?vue&type=template&id=fee154de&scoped=true"
import script from "./CreateOrderButton.vue?vue&type=script&lang=ts"
export * from "./CreateOrderButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee154de",
  null
  
)

export default component.exports